import { useEffect, useState } from "react";
import { isMobile, subscribeToLayoutChange } from "../../utils/deviceInfo";

const getLayoutKey = () => (isMobile ? "mobile-layout" : "desktop-layout");

// Most screens read isMobile while rendering and sit behind connect(), so they
// only pick up a layout change when remounted. Use layoutKey as the key of the
// subtree that has to switch; it only changes when the breakpoint is crossed.
const MobileLayoutBoundary = ({ render }) => {
  const [layoutKey, setLayoutKey] = useState(getLayoutKey);

  useEffect(() => {
    return subscribeToLayoutChange(() => setLayoutKey(getLayoutKey()));
  }, []);

  return render(layoutKey);
};

export default MobileLayoutBoundary;
